import {Component} from 'react';
import h from 'react-hyperscript';
import content from 'Assets/data/report-card-overview.json';
import NoReportState from './NoReportState';
import ReportAvailableState from './ReportAvailableState';
import SurveyAvailableState from './SurveyAvailableState';
import SurveyCompleteState from './SurveyCompleteState';
import ReportPendingState from './ReportPendingState';
class SurveyReportStatus extends Component {
  render() {
    let component;

    switch (this.props.activeComponent) {
      case 'ReportAvailableState':
        component = h(
            ReportAvailableState,
            {
              surveyTitle: this.props.surveyStatus.survey_name,
              shareInfo: content.share_info,
              content: content.status.report_available,
              latestReport: this.props.latestReport,
              userStatus: this.props.userStatus,
              calendarContent: this.props.calendarContent,
              calendarDate: this.props.calendarDate,
              nextSurveyDate: this.props.nextSurveyDate,
              data: this.props.reportList,
              csrf: this.props.csrf,
            },
            null
        );
        break;
      case 'ReportPendingState':
        component = h(
            ReportPendingState,
            {
              surveyTitle: this.props.surveyStatus.survey_name,
              shareInfo: content.share_info,
              content: content.status.report_pending,
              latestReport: this.props.latestReport,
              reportLoading: this.props.reportLoading,
              reportMissingDataNotFound: this.props.reportMissingDataNotFound,
              shareUrl: this.props.surveyStatus.share_survey_url,
              numRespondents: this.props.surveyStatus.num_respondents,
              expirationDate: this.props.userStatus.survey_open_period_closed,
              daysLeft: this.props.surveyStatus.days_left,
              loading: this.props.reportLoading,
              csrf: this.props.csrf,
            },
            null
        );
        break;
      case 'SurveyAvailableState':
        component = h(
            SurveyAvailableState,
            {
              surveyTitle: this.props.surveyStatus.survey_name,
              shareInfo: content.share_info,
              content: content.status.survey_available,
              latestReport: this.props.latestReport,
              shareUrl: this.props.surveyStatus.share_survey_url,
              numRespondents: this.props.surveyStatus.num_respondents,
              expirationDate: this.props.userStatus.survey_open_period_closed,
              daysLeft: this.props.surveyStatus.days_left,
              userStatus: this.props.userStatus,
              googleUser: this.props.googleUser,
              csrf: this.props.csrf,
              idToken: this.props.idToken,
              setProductWindowsLoading: this.props.setProductWindowsLoading,
            },
            null
        );
        break;
      case 'SurveyCompleteState':
        component = h(
            SurveyCompleteState,
            {
              surveyTitle: content.status.survey_complete.title,
              shareInfo: content.share_info,
              content: content.status.survey_complete,
              latestReport: this.props.latestReport,
              shareUrl: this.props.surveyStatus.share_survey_url,
              shareMessage: content.status.survey_complete.shareMessage,
              ctas: content.ctas,
              numRespondents: this.props.surveyStatus.num_respondents,
              expirationDate: this.props.userStatus.survey_open_period_closed,
              reportAvailableDate: this.props.userStatus.dates
                  .report_available_date,
              daysLeft: this.props.surveyStatus.days_left,
              userStatus: this.props.userStatus,
              googleUser: this.props.googleUser,
              csrf: this.props.csrf,
              idToken: this.props.idToken,
              setProductWindowsLoading: this.props.setProductWindowsLoading,
            },
            null
        );
        break;
      default:
        component = h(
            NoReportState,
            {
              content: content.status.empty,
              calendarContent: this.props.calendarContent,
              calendarDate: this.props.calendarDate,
              nextSurveyDate: this.props.userStatus.dates.next_survey_date,
              userStatus: this.props.userStatus,
              googleUser: this.props.googleUser,
              csrf: this.props.csrf,
              idToken: this.props.idToken,
            },
            null
        );
    }
    return component;
  }
}

export default SurveyReportStatus;
